module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/04-8efa75b4ac7844d281b32f5120887412.jpg";